// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"46f827f5","334":"bca60c56"}[chunkId] + ".chunk.css";
};